import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../shared/config/app-config';
import { UserService } from '../../../shared';

@Component({
  selector: 'app-export-survey',
  templateUrl: './export-survey.component.html',
  styleUrls: ['./export-survey.component.css']
})
export class ExportSurveyComponent implements OnInit {
  
  downloadMultiSurvey: any = environment.downloadMultiSurvey;
  @Input() patientSWFId: number = null

  constructor(private userService: UserService) { }

  currentuserDetails:any
  ngOnInit() {
    this.userService.currentUser.subscribe(data=>{this.currentuserDetails=data})
    this.fetchSurveyGroupList()
  }

  selectedSurveyGrpId:number =null
  intravals = []
  surveyDetailList = []
  surveyGroupList = []
/* -----------------------------fetch survey gruop lists----------------------------------------*/
  fetchSurveyGroupList() {
    this.selectedSurveyGrpId=null
    var payload={"patientSwfId":this.patientSWFId}
    this.userService.fetchAllMultipleCompletedSurveys(payload).subscribe(data => {
      this.surveyGroupList = data
      this.surveyGroupList.reverse();
      if(this.surveyGroupList.length>0)
      {
        this.surveyGrpChange(this.surveyGroupList[0].id)
      }
      
    })

  }
/*------------------------------survey group change function------------------------------------*/
  surveyGrpChange(event) {
    this.selectedSurveyGrpId=Number(event)
    this.surveyDetailList=[]
    this.intravals=[]
    this.selectAll=true
    this.errorSpan=false
    document.getElementById("surveyGrpName").innerHTML=''
    let requestjson = { "patientSwfId": this.patientSWFId, "exportSurveyMasterId": Number(event) }
    this.userService.fetchCompeletedSurveyList(requestjson).subscribe(data => {
        if(data)
        {
          if(data.surveyList.length>0)
          { 
            document.getElementById("surveyGrpName").innerHTML=data.exportedSurveyName
            this.intravals = data.intervalNameList
            this.surveyDetailList =data.surveyList
            this.surveyDetailList.forEach(element=>{
              element.forEach(element1=>{element1.checked=false})
            })
          }
        }
    })
  } 
  
  /* -----------------------checkbox change function-----------------------------*/
  selectAll=true
  selectionChange()
  { 
    var count=0
    this.surveyDetailList.forEach(element=>{
      element.forEach(element1=>{
        if(element1.surveyAvailable=='true' && element1.checked==false)
        { 
          count++
        }
        else if(element1.checked==true)
         this.errorSpan=false
      })
    })

    if(count>0)
    { 
      this.selectAll=true
    }
    else
      {
        this.selectAll=false
      }
  }
/* ----------------------------select all survey function----------------------------*/
  selectAllSurvey()
  { 
    this.selectAll=false
    this.surveyDetailList.forEach(element=>{
      element.forEach(element1=>{
        if(element1.surveyAvailable=='true')
        { 
          element1.checked=true
        }}
        )
    })
    this.errorSpan=false
  }
 /*-----------------------------un select all survey function --------------------------*/
  unSelectAllSurvey()
  { 
    this.selectAll=true
    this.surveyDetailList.forEach(element=>{
      element.forEach(element1=>{
        if(element1.surveyAvailable=='true')
        { 
          element1.checked=false
        }}
        )
    })
  }
  /* --------------------------- get all selected  hspPatSurveyId ----------------------*/
  errorSpan:boolean=false
  export()
  { 
    var hspPatSurveyId=[]
    var count=0
    this.surveyDetailList.forEach(element=>{
      element.forEach(element1=>{
        if(element1.checked==true)
        { 
          count++
          hspPatSurveyId.push(element1.hpsmId)
        }}
        )
    })
    if(count>0)
      setTimeout(()=>{this.onPrint(hspPatSurveyId) },100)
    else
       this.errorSpan=true
  }
  /*---------------------------print survey----------------------------------------------*/
  onPrint(hspPatSurveyId) {
    let printContents;
    let data:any = {
      preview:true,
      'hspPatSurveyIdArr':hspPatSurveyId,
      'patientSwfId':this.patientSWFId,
      'loginUserId':String(this.currentuserDetails.item.userAccountId),
      "lang": this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data=btoa(data)
    printContents = this.downloadMultiSurvey + data
    window.open(printContents, '_blank', 'top=0,left=0,height=100%,width=auto');
    this.closeModal.emit()
  }
  
  @Output() closeModal=new EventEmitter <any>();

  getWidth()
  { 
    return  (this.intravals.length>5  ? 100+((this.intravals.length-5)* 16.66)+'%' : 100+'%' );
  }
}